import XLSX from 'xlsx'
import { Cell, Column, ReferenceConfig, Sheet } from './types'

// List the cells like
// [
//  [A1, A2, A3, ...],
//  [B1, B2, B3, ...],
//  ...
// ]
export function sheet2cols(sheet: XLSX.WorkSheet): Column[] {
  // Sheet has keys like '0', '1', etc. that are the row numbers,
  // so use a while loop to count them.
  let numRows = 0
  while (sheet[numRows]) {
    numRows++
  }

  // Assume the sheet is rectangular not jagged
  const numCols = sheet[0] ? sheet[0].length : 0

  const cols: Column[] = []
  for (let i = 0; i < numCols; i++) {
    const col: Column = []
    for (let j = 0; j < numRows; j++) {
      col.push(sheet[j][i])
    }
    cols.push(col)
  }

  return cols
}

// List the cells like
// [
//  [A2, B2, C2, ...],
//  [A3, B3, C3, ...],
//  ...
// ]
//
// Notice that the first (header) row is skipped
export function sheet2rows(sheet: XLSX.WorkSheet): Cell[][] {
  // skip header row
  const output: Cell[][] = []
  let rowNum = 1
  while (sheet[rowNum]) {
    const row = sheet[rowNum]
    output.push(row)
    rowNum++
  }
  return output
}

// Topologically sort sheets based on their references, so that if sheet B depends on sheet A
// then sheet A will be inserted first.
export function toposort(sheets: Sheet[]): Sheet[] {
  const sheetBySlug = new Map<string, Sheet>()
  sheets.forEach((sheet) => sheetBySlug.set(sheet.config.slug, sheet))

  const sorted: Sheet[] = []
  const visited = new Set<string>()

  while (sheetBySlug.size > 0) {
    const unvisited = sheets.filter((sheet) => !visited.has(sheet.config.slug))

    const unvisitedWithNoReferences = unvisited.filter((sheet) => {
      const references = sheet.config.fields.filter((field) => field.type === 'reference')
      const referencedSheetSlugs = references.map((field) => (field.config as ReferenceConfig).ref)
      return referencedSheetSlugs.every((slug) => !sheetBySlug.has(slug))
    })

    if (unvisitedWithNoReferences.length === 0) {
      throw new Error('Circular reference detected')
    }

    unvisitedWithNoReferences.forEach((sheet) => {
      sorted.push(sheet)
      visited.add(sheet.config.slug)
      sheetBySlug.delete(sheet.config.slug)
    })
  }

  return sorted
}
